var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row numberSliderHightLightImages",
      attrs: { id: _vm.model.componentSetting.id }
    },
    [
      _c("div", { staticClass: "col-lg-1" }),
      _c("div", { staticClass: "col-lg-10" }, [
        _c(
          "div",
          {
            staticClass:
              "white-background box-shadow p-4 mb-4 step-part active",
            attrs: { id: "step2a" }
          },
          [
            _c("h3", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.model.componentSetting.title))
            ]),
            _c("p", { staticClass: "bodytext" }, [
              _vm._v(_vm._s(_vm.model.componentSetting.description))
            ]),
            _vm._m(0),
            _c(
              "vue-slider",
              _vm._b(
                {
                  ref: "slider",
                  scopedSlots: _vm._u([
                    {
                      key: "tooltip",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "vue-slider-dot-tooltip-inner vue-slider-dot-tooltip-inner-bottom"
                            },
                            [
                              _vm._v(_vm._s(value) + " "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getUnitView(
                                      _vm.model.componentSetting.unit
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.data.model,
                    callback: function($$v) {
                      _vm.$set(_vm.data, "model", $$v)
                    },
                    expression: "data.model"
                  }
                },
                "vue-slider",
                _vm.data.options,
                false
              )
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-lg-1" })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("img", {
        staticClass: "house-image small",
        attrs: { src: "images/calculator/small.png", alt: "" }
      }),
      _c("img", {
        staticClass: "house-image medium",
        attrs: { src: "images/calculator/medium.png", alt: "" }
      }),
      _c("img", {
        staticClass: "house-image big",
        attrs: { src: "images/calculator/big.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }